import React, { useState, useEffect } from 'react'
import './offerButton.css'
import { PopUp } from '../../Pages/LandingPage/PopUp'
import { Button, useDisclosure } from '@nextui-org/react'
import { useLocation } from 'react-router-dom'

const OfferButton = () => {
  const [isButtonVisible, setIsButtonVisible] = useState(false)
  const modalState = useDisclosure()
  const { onOpen } = modalState
  const location = useLocation()

  useEffect(() => {
    const firstBlock = document.getElementById('first-block')
    
    if (!firstBlock) {
      // If there's no first-block (e.g., on subpages), show the button immediately
      setIsButtonVisible(true)
      return
    }

    // On pages with first-block (like LandingPage), use IntersectionObserver
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        setIsButtonVisible(!entry.isIntersecting)
      },
      {
        root: null,
        rootMargin: '-410px',
        threshold: 0,
      }
    )

    observer.observe(firstBlock)

    return () => observer.disconnect()
  }, [location.pathname])

  return (
    <div>
      {isButtonVisible && (
        <div className="mobile-buttons">
          <Button
            variant="shadow"
            onClick={onOpen}
            className="mobile-button book-appointment"
          >
            Get a free Quote
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
              <path d="M7.50008 1.66659H4.83341C3.43328 1.66659 2.73322 1.66659 2.19844 1.93907C1.72803 2.17875 1.34558 2.5612 1.1059 3.03161C0.833412 3.56639 0.833412 4.26645 0.833412 5.66659V9.99992C0.833412 10.7749 0.833412 11.1624 0.918598 11.4803C1.14977 12.343 1.82363 13.0169 2.68636 13.2481C3.00428 13.3333 3.39177 13.3333 4.16675 13.3333V15.2795C4.16675 15.7235 4.16675 15.9456 4.25777 16.0596C4.33693 16.1588 4.45697 16.2165 4.58386 16.2163C4.72977 16.2162 4.90314 16.0775 5.24988 15.8001L7.23776 14.2098C7.64384 13.8849 7.84689 13.7225 8.07298 13.607C8.27358 13.5045 8.4871 13.4296 8.70776 13.3843C8.95647 13.3333 9.21649 13.3333 9.73654 13.3333H11.0001C12.4002 13.3333 13.1003 13.3333 13.6351 13.0608C14.1055 12.8211 14.4879 12.4386 14.7276 11.9682C15.0001 11.4334 15.0001 10.7334 15.0001 9.33325V9.16659M15.1012 1.56548C16.0775 2.5418 16.0775 4.12471 15.1012 5.10102C14.1249 6.07733 12.542 6.07733 11.5656 5.10102C10.5893 4.12471 10.5893 2.5418 11.5656 1.56548C12.542 0.589174 14.1249 0.589174 15.1012 1.56548Z" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </Button>
          {modalState.isOpen && (
            <PopUp modalState={modalState} title="Get in touch" />
          )}
        </div>
      )}
    </div>
  )
}

export default OfferButton
